"use client"

import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible"
import { ISublink } from "@/lib/types/type-menu"
import { ChevronDown, type LucideIcon } from "lucide-react"
import * as React from "react"

interface DropdownItemProps {
  title: string
  icon?: LucideIcon
  items: ISublink[]
  onItemClick: () => void
  level?: number
}

export function DropdownItem({ title, icon: Icon, items, onItemClick, level = 0 }: DropdownItemProps) {
  const [isOpen, setIsOpen] = React.useState(false)

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen} className="mb-1">
      <CollapsibleTrigger className="flex items-center justify-between w-full px-4 py-3 rounded-2xl text-gray-700 hover:bg-gray-100/80 hover:text-gray-900 transition-all duration-200 group">
        <div className="flex items-center space-x-3">
          {Icon && <Icon className="h-5 w-5 text-gray-500 group-hover:text-gray-700 transition-colors" />}
          <span className="font-medium">{title}</span>
        </div>
        <ChevronDown
          className={`h-4 w-4 text-gray-500 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
        />
      </CollapsibleTrigger>
      <CollapsibleContent className="overflow-hidden data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down">
        <div className={`mt-1 ${level === 0 ? 'ml-6' : 'ml-4'} space-y-1`}>
          {items.map((item, index) => (
            item.sublinks && item.sublinks.length > 0 ? (
              <DropdownItem
                key={index}
                title={item.title}
                icon={item.icon}
                items={item.sublinks}
                onItemClick={onItemClick}
                level={level + 1}
              />
            ) : (
              <a
                key={index}
                href={item.path}
                onClick={onItemClick}
                className="flex items-center space-x-2 px-4 py-2.5 rounded-xl text-sm text-gray-600 hover:bg-gray-50 hover:text-gray-900 transition-all duration-200"
              >
                {item.icon && <item.icon className="h-4 w-4 text-gray-500" />}
                <span>{item.title}</span>
              </a>
            )
          ))}
        </div>
      </CollapsibleContent>
    </Collapsible>
  )
}
